import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Image } from "react-bootstrap";

const Error_401 = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="content-404 d-flex justify-content-center align-items-center h-100">
        <div className="text-center">
          <Image src="/assets/images/401-img.svg" className="img-404" />
          <h1 className="font-20 font-weight-bold mb-2 heading-color">
            401: Unauthorized!
          </h1>
          <p className="font-13 font-weight-normal text-color mb-4">
            You either tried some shady route or you came here by mistake.
            Whichever it is, try using <br /> the navigation menu
          </p>
          <button onClick={() => navigate("/")} className="add-new-btn">
            {" "}
            <img
              src="/assets/images/arrow-error.svg"
              alt=""
              className="me-2"
            />{" "}
            Back to home
          </button>
        </div>
      </div>
    </>
  );
};

export default Error_401;
